import { useTaskSideDrawer } from 'ComponentLibrary/src/context/TaskSideDrawerContext'
import { TaskSideDrawer } from 'ClientPortal/src/pages/SideDrawers/TaskSideDrawer'
import { ErrorBoundary } from 'ComponentLibrary'

export const TaskSideDrawerWithContext = () => {
    const { taskId, closeTaskSideDrawer } = useTaskSideDrawer()

    return (
        <ErrorBoundary>
            <TaskSideDrawer key={taskId} taskId={taskId} onCloseDrawer={closeTaskSideDrawer} />
        </ErrorBoundary>
    )
}
